import * as React from 'react';
import validator, {
  Rule,
  RulesMessages,
  ValidationResponse
} from '../utils/validator';
import '../css/form-aux-checkbox.sass';

interface AuxiliaryCheckBoxProps {
  required?: boolean;
  label: React.ReactNode;
  id: string;
  name: string;
  checked: boolean;
  disabled?: boolean;
  hasError?: boolean;
  errors?: any;
  onChange?: Function;
  onBlur?: Function;
  onComplete?: Function;
  onError?: Function;
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  theme?: 'night' | 'day';
}

interface AuxiliaryCheckBoxState {
  inputValue?: boolean;
  validationResponse?: ValidationResponse;
}

export default function AuxiliaryCheckBox(props: AuxiliaryCheckBoxProps) {
  const [state, setState] = React.useState<AuxiliaryCheckBoxState>({
    inputValue: props.checked || false
  });

  const { theme = 'day' } = props;

  const componentPropsRules: Rule[] = [];
  if (props.validationRules) {
    componentPropsRules.push(...props.validationRules);
  }

  const componentState = { state, setState };
  if (props.required) {
    componentPropsRules.push({
      ruleName: 'checkForTrue',
      message: props.rulesMessages && props.rulesMessages.checkForTrue,
      defaultMessage: `Required.`
    });
  }
  const componentValidator = {
    validationRules: [
      {
        fieldName: 'inputValue',
        rules: componentPropsRules
      }
    ]
  };
  return (
    <div className="auxiliary-checkbox">
      <input
        type="checkbox"
        checked={props.checked}
        disabled={props.disabled}
        id={props.id}
        className={`${theme}${
          props.hasError || validator.hasError(componentState, 'inputValue')
            ? ' invalid'
            : ''
        }`}
        onBlur={(e: any) => {
          if (validator.validateComponent(componentState, componentValidator)) {
            if (props.onComplete !== undefined) {
              props.onComplete(e);
            }
          } else if (props.onError !== undefined) {
            props.onError();
          }
          if (props.onBlur !== undefined) {
            props.onBlur(e);
          }
        }}
        onChange={(e: any) => {
          if (props.onChange !== undefined) {
            props.onChange({
              ...e,
              target: {
                ...e.target,
                valid: !props.required || e.target.checked
              }
            });
          }
          setState({ ...state, inputValue: e.target.checked });
        }}
      />
      <span className="icon"> </span>
      <label
        className={`${props.disabled ? 'disabled' : ''}`}
        htmlFor={props.id}
      >
        {props.label}
      </label>
      {(!validator.isAllValid(componentState) &&
        validator.getErrors(componentState)) ||
        (props.hasError && props.errors)}
    </div>
  );
}
